// extracted by mini-css-extract-plugin
export default {"popup":"Header_popup__IlBrY","header_light":"Header_header_light__rnQJU","header":"Header_header__MY7fH"};